export default __webpack_public_path__ + "static/chris-24d32be443f85033a8bc8ae830db27cf.jpeg";